/**
 * seed-calculator-1
 */

// Module dependencies
import 'protons';

// Module template
import './_seed-calculator-1.twig';

// All Vue widgets only execute on existence of DOM
import VueCalculator from 'lib/vue-widget/src/vue-calculator';

// Render Vue elements as soon as possible
if (document.getElementById('vue-calculator')) {
  VueCalculator('#vue-calculator');
}

export const name = 'seed-calculator-1';
export function disable() {}
export function enable() {}
export default enable;
